import React, { useState, useEffect } from "react"

import { AvRadio } from "availity-reactstrap-validation"

import ApplicationDetails from "../../components/Application/ApplicationDetails"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// services
import Staff from "services/staff/Staff"
import { trim } from "lodash"
import Application from "services/applications/Application.service"
let appService = null

import ExportLicense from "./ExportLicense/index"
import PlasticBags from "./PlasticBags/index"
import DisposalGuidance from "./Disposal/index"
import DeliveryPartner from "./DeliveryPartner/index"
import AccreditationRequest from "./AccreditationRequest/index"
import NoObjectionRequest from "./NoObjectionRequest/index"
import EnvironmentalAuditRequest from "./EnvironmentalAudit/index"


const staffService = new Staff()

const AssignStaff = props => {
  const [staffList, setStaffList] = useState([])
  const [disabled, setdisabled] = useState(true)
  const [headInfo, setHeadInfo] = useState({})
  const [mounted, setmounted] = useState(false)
  const [appDetails, setappDetails] = useState()
  const [serviceComponent, setserviceComponent] = useState()

  useEffect(() => {
    appService = new Application(localStorage.getItem("authUser"))

    setHeadInfo(JSON.parse(localStorage.getItem("authUser")))
    appService
      .getApplicationDetails(props.location.search.split("=")[1])
      .then(response => {
        //console.log(response)
        if (response.status) {
          setappDetails(response.data)
          setmounted(true)

          if (response.data.service_id === 1) {
            setserviceComponent(<PlasticBags appDetails={response.data} />)
          } else if (response.data.service_id === 2) {
            setserviceComponent(<DisposalGuidance appDetails={response.data} />)
          } else if (response.data.service_id === 3) {
            setserviceComponent(<ExportLicense appDetails={response.data} />)
          } else if (response.data.service_id === 4) {
            setserviceComponent(<ExportLicense appDetails={response.data} />)
          } else if (response.data.service_id === 6) {
            setserviceComponent(<DeliveryPartner appDetails={response.data} />)
          }  else if (response.data.service_id === 17001) {
            setserviceComponent(<AccreditationRequest appDetails={response.data} />)
          }  else if (response.data.service_id === 17002) {
            setserviceComponent(<NoObjectionRequest appDetails={response.data} />)
          }  else if (response.data.service_id === 17003) {
            setserviceComponent(<EnvironmentalAuditRequest appDetails={response.data} />)
          } else {
          }
        }
      })
  }, [])

  const submitForm = v => {
    appService.assignStaff(v).then(response => {
      if (response.status) {
        console.log(response)
        props.history.push("/dashboard")
      } else {
        console.log(response)
      }
    })
  }

  const searchStaff = item => {
    item = trim(item)
    if (item === "") {
      return
    }
    staffService.searchStaff(item).then(response => {
      if (response.status) {
        if (response.data.length > 0) {
          setdisabled(false)
        } else {
          setdisabled(true)
        }
        var options = []
        options = response.data.map((staff, index) => (
          <AvRadio
            key={index}
            value={staff.id}
            label={staff.first_name + " " + staff.last_name}
          />
        ))
        setStaffList(options)
      }
    })
  }
  return (
    <>{serviceComponent}</>
    // <React.Fragment>
    //   <div className="page-content">
    //     <MetaTags>
    //       <title>Assign Staff</title>
    //     </MetaTags>
    //     <Container fluid>
    //       {/* Render Breadcrumbs */}
    //       <Breadcrumbs maintitle="Applications" title="Assign Staff" />

    //       <Row>
    //         <Col lg="12">
    //           <Card>
    //             <CardBody>
    //               <Row className="justify-content-center">
    //                 <Col lg={5}>
    //                   <h5 className="mt-0 font-size-18 mb-4">
    //                     <i className="ti-user text-primary me-2"></i> Assign
    //                     Staff
    //                   </h5>

    //                   <form className="app-search">
    //                     <div className="position-relative">
    //                       <input
    //                         onChange={e => {
    //                           searchStaff(e.target.value)
    //                         }}
    //                         type="text"
    //                         className="form-control"
    //                         placeholder={"Search staff..."}
    //                       />
    //                       <span className="fa fa-search"></span>
    //                     </div>
    //                   </form>

    //                   <div className="mb-3 mt-3">
    //                     <AvForm
    //                       onValidSubmit={(e, v) => {
    //                         submitForm(v)
    //                       }}
    //                     >
    //                       <h4>Select Staff</h4>
    //                       <AvField
    //                         type="hidden"
    //                         name="assigned_by"
    //                         value={headInfo.id}
    //                       />
    //                       {mounted && (
    //                         <AvField
    //                           type="hidden"
    //                           name="application_id"
    //                           value={appDetails.id}
    //                         />
    //                       )}

    //                       <AvRadioGroup
    //                         name="staff_id"
    //                         required
    //                         errorMessage="Please select staff"
    //                       >
    //                         {staffList}
    //                       </AvRadioGroup>
    //                       <div className="mt-3">
    //                         <button
    //                           disabled={disabled}
    //                           type="submit"
    //                           className="btn btn-lg btn-primary col-12"
    //                         >
    //                           Assign Application to Staff
    //                         </button>
    //                       </div>
    //                     </AvForm>
    //                   </div>
    //                 </Col>

    //                 {mounted && <ApplicationDetails appDetails={appDetails} />}
    //               </Row>
    //             </CardBody>
    //           </Card>
    //         </Col>
    //       </Row>
    //     </Container>
    //   </div>
    // </React.Fragment>
  )
}

export default AssignStaff
